import React from 'react';
import './blog-post.css';

import tea1 from './pictures/tea1.jpg';
import tea2 from './pictures/tea2.JPG';
import tea3 from './pictures/tea3.jpg';
import tea4 from './pictures/tea4.jpg';
import tea5 from './pictures/tea5.jpg';
import tea6 from './pictures/tea6.jpg';
import tea7 from './pictures/tea7.jpg';
import tea8 from './pictures/tea8.jpg';
import tea9 from './pictures/tea9.jpg';


//import reportWebVitals from './reportWebVitals';

const Teaparty = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Winter MM2: Tea Party Recap</h2>
                    <p class="site-post-meta">February 27th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>                   
                    WiC members gathered for a sophisticated Tea Party. 
                    Despite the rainy weather outside, we were able to relax indoors 
                    with a variety of pastries, cucumber sandwiches, and warm drinks while 
                    listening to classical music and mingling! 
                    Thank you to all of our members who were able to take time out of 
                    their busy schedules to come and support our event, 
                    we couldn't have done this without you! 
                    <br></br>
                     
                    </p>
                     <img src={tea1} alt=""/>
                     <img src={tea2} alt=""/>
                     <img src={tea3} alt=""/>
                     <img src={tea4} alt=""/>
                     <img src={tea5} alt=""/>
                     <img src={tea6} alt=""/>
                     <img src={tea7} alt=""/>
                     <img src={tea8} alt=""/>
                     <img src={tea9} alt=""/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Teaparty;

